import React from 'react';
import { Stack } from '@mui/material';
import { TextsmsOutlined } from '@mui/icons-material';
import Button from 'domains/core/components/Button';
import PageHeader from 'domains/core/components/PageHeader';
import SmsSendTestIconButton from './SmsSendTest';

type SmsHeaderSectionProps = {
    content: string;
    isLoading: boolean;
    onSaveAndExit: () => void;
};

const SmsHeaderSection = React.memo(({ content, isLoading, onSaveAndExit }: SmsHeaderSectionProps) => (
    <PageHeader
        icon={<TextsmsOutlined color="action" fontSize="inherit" />}
        header="sms"
        headerOthers={
            <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
                <SmsSendTestIconButton content={content} />
                <Button disabled={isLoading} onClick={onSaveAndExit} variant="outlined">
                    Save & Exit
                </Button>
            </Stack>
        }
    />
));

export default SmsHeaderSection;
